import Reveal from "@/components/base/Reveal";
import SectionHeader from "@/components/base/SectionHeader";
import { features, type Feature } from "@/mocks/melons";

function FeatureCard({ f, index }: { f: Feature; index: number }) {
  return (
    <Reveal delay={index * 80}>
      <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 shadow-soft transition-transform duration-300 hover:-translate-y-1.5">
        <div className="relative aspect-[10/7] overflow-hidden">
          <img
            src={f.image}
            alt={`${f.cat}焦点大瓜：${f.title}`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-50/95 px-2.5 py-1 text-xs font-medium text-foreground-800">
            <i className="ri-price-tag-3-line text-primary-600" /> {f.cat}
          </span>
          <span className="absolute right-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-500/95 px-2.5 py-1 text-xs font-medium text-background-50">
            <i className="ri-flashlight-fill" /> {f.status}
          </span>
        </div>
        <div className="flex flex-1 flex-col p-5">
          <h3 className="text-base font-semibold leading-snug text-foreground-900 md:text-lg">{f.title}</h3>
          <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">{f.brief}</p>
          <div className="mt-4">
            <div className="flex items-center justify-between text-xs text-foreground-600">
              <span>围观热度</span>
              <span className="flex items-center gap-1">
                <i className="ri-chat-3-line text-foreground-400" /> {f.comments} 讨论
              </span>
            </div>
            <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-background-100">
              <div className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500" style={{ width: `${f.heat}%` }} />
            </div>
          </div>
          <a
            href="#talk"
            className="mt-4 inline-flex items-center justify-between rounded-lg border border-background-300 bg-background-100 px-3.5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
          >
            围观这条大瓜的讨论
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </article>
    </Reveal>
  );
}

export default function Features() {
  return (
    <section id="features">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeader
          eyebrow="焦点大瓜"
          eyebrowIcon="ri-star-fill"
          title="本月深度围观专题"
          desc="编辑部把散落的热议整理成可读的专题瓜，标清来源与进展，带你从「只看热闹」升级到「看懂门道」。"
          action={
            <a href="#channels" className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700">
              更多栏目内容 <i className="ri-arrow-right-line" />
            </a>
          }
        />

        <div className="mt-8 grid gap-5 sm:grid-cols-2">
          {features.map((f, i) => (
            <FeatureCard key={f.id} f={f} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}